import styled from 'styled-components'

export const Container = styled.div`
  width: 310px;
  height: 100%;
  background: ${({ theme }) => theme.zds.colors.neutral1000} 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 4px ${props => props.theme.colors.colorBlack29};
  border-radius: 0px 0px 4px 4px;

  li {
    display: grid;
    grid-template-columns: 90% 10%;
    margin: 10px 0px 10px 0px;

    button {
      border: none;
      background: transparent;
      transition: 0.3s;
      cursor: pointer;
      padding-right: 10px;
      transform-origin: 35% 50%;

      svg {
        stroke: ${props => props.theme.colors.color545e6c};
        stroke-width: 2px;
        height: 12px;
        width: 20px;
        transition: 0.3s;
      }
    }
  }
  .subTypes {
    flex-direction: column;
    padding-left: 30px;
    font-size: 15px;
    width: 100%;
  }
`
